// Customers Groups Getters

export const getFullGroupsList = state => {
  return state.fullGroupsList
}

export const getGroupsList = state => {
  return state.groupsList
}

export const getGroupInfo = state => {
  return state.groupInfo
}
